// extracted by mini-css-extract-plugin
export default {"container":"RichTextEditorContainer_container__nY7Nm"};